import * as React from 'react';
export const IcHashtag = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.5 13.59h-3.21l.64-3h2.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-1.92l.54-2.5a1.498 1.498 0 10-2.93-.63l-.67 3.13h-3.13l.54-2.5A1.498 1.498 0 109 4.46l-.67 3.13H4.52c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h3.16l-.64 3H4.51c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h1.88l-.5 2.33c-.17.81.34 1.61 1.15 1.78.11.02.21.03.32.03.69 0 1.31-.48 1.46-1.19l.63-2.95h3.13l-.5 2.33c-.17.81.34 1.61 1.15 1.78.11.02.21.03.32.03.69 0 1.31-.48 1.46-1.19l.63-2.95h3.85c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h.01zm-9.4 0l.64-3h3.13l-.64 3H10.1z'
      fill='currentColor'
    />
  </svg>
);
